import { render, staticRenderFns } from "./PackageTransaction.vue?vue&type=template&id=2b21a8fa&"
import script from "./PackageTransaction.vue?vue&type=script&lang=js&"
export * from "./PackageTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PackageTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageTransaction.vue"
export default component.exports